import React from 'react';

function Android(props) {
    return (
        <div>
            Android
        </div>
    );
}

export default Android;